import {memo} from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';

export interface IMessageContainer {
    title?: string;
    content?: string;
    buttonContent?: string;
    // name会有唯一对应的class用于配制
    name?: string;
    onChangeVisible: (target: boolean) => void;
    // 关闭所对应的回调
    onClickButtonToClose?: any;
    onClickCancel?: any;
    children?: any;
}

const MessageContainer: React.FC<IMessageContainer> = ({
    title, content, buttonContent, children, onClickCancel,
    onChangeVisible, onClickButtonToClose, name,
}) => {
    const close = () => {
        // onChangeVisible(false);
        onClickButtonToClose && onClickButtonToClose();
    };

    const cancel = () => {
        onClickCancel && onClickCancel();
    };


    return (
        <>
            {children}
            <div onClick={(e) => e.stopPropagation()}>
                {
                    content && !title ?
                        // 此时只有content，是单行布局
                        <div
                            className={classNames(styles.containerOnlyTitle, name && styles[name])}
                        >
                            <span className={styles.containerOnlyTitleContent}>{content}</span>
                        </div>
                        :
                        // 此时所有消息都有为正常布局
                        <div
                            className={classNames(styles.container, name && styles[name])}
                        >
                            <div className={styles.containerInside}>
                                {title && <div className={styles.title}>{title}</div>}
                                {content && <div className={styles.content}>{content}</div>}
                                {buttonContent &&
                                    <div className={styles.button} onClick={close}>
                                        <div className={styles.buttonContent}>{buttonContent}</div>
                                    </div>
                                }
                                <div className={styles.containerCancel} onClick={cancel}></div>
                            </div>
                        </div>
                }
            </div>
        </>
    );
};

export default memo(MessageContainer);
